import reduxConnector from 'root/src/shared/util/reduxConnector'

import formFieldTypes from 'root/src/client/logic/form/selectors/formFieldTypes'
import fieldSectionsSelector from 'root/src/client/logic/form/selectors/fieldSectionsSelector'
import fieldSectionsHeadersSelector from 'root/src/client/logic/form/selectors/fieldSectionsHeadersSelector'
import formSubmits from 'root/src/client/logic/form/selectors/formSubmits'
import postFormSubmits from 'root/src/client/logic/form/selectors/postFormSubmits'
import formSubmitError from 'root/src/client/logic/form/selectors/formSubmitError'
import formTitle from 'root/src/client/logic/form/selectors/formTitle'
import formSubTitle from 'root/src/client/logic/form/selectors/formSubTitle'
import formPreSubmitText from 'root/src/client/logic/form/selectors/formPreSubmitText'
import formPostSubmitText from 'root/src/client/logic/form/selectors/formPostSubmitText'
import formPreSubmitCaption from 'root/src/client/logic/form/selectors/formPreSubmitCaption'
import formPostSubmitCaption from 'root/src/client/logic/form/selectors/formPostSubmitCaption'
import formType from 'root/src/client/logic/form/selectors/formType'
import visibleLoadingBlockSelector from 'root/src/client/logic/form/selectors/visibleLoadingBlockSelector'
import isAuthenticated from 'root/src/client/logic/auth/selectors/isAuthenticated'
import creatorDataSelector from 'root/src/client/logic/app/selectors/creatorDataSelector'
import submitsFullWidth from 'root/src/client/logic/form/selectors/submitsFullWidth'
import headerTypeSelector from 'root/src/client/logic/list/selectors/headerTypeSelector'
import formFullWidth from 'root/src/client/logic/form/selectors/formFullWidth'
import doubleColumn from 'root/src/client/logic/form/selectors/doubleColumn'
import formOutputSelector from 'root/src/client/logic/form/selectors/formOutputSelector'
import prePopulateFormOnSelector from 'root/src/client/logic/form/selectors/prePopulateFormOnSelector'
import submitsRowSelector from 'root/src/client/logic/form/selectors/submitsRowSelector'
import fieldThemeSelector from 'root/src/client/logic/form/selectors/fieldThemeSelector'
import cancelButton from 'root/src/client/logic/form/selectors/cancelButton'
import isMobileResSelector from 'root/src/client/logic/app/selectors/isMobileResSelector'
import formOutputData from 'root/src/client/logic/form/selectors/formOutputData'
import linksSelector from 'root/src/client/logic/form/selectors/linksSelector'
import tabErrorSelector from 'root/src/client/logic/form/selectors/tabErrorSelector'
import hotjarRecordingSelector from 'root/src/client/logic/list/selectors/hotjarRecordingSelector'
import hideSubmitErrorSelector from 'root/src/client/logic/form/selectors/hideSubmitErrorSelector'
import previousRouteSelector from 'root/src/client/logic/project/selectors/previousRouteSelector'
import formTogglesSelector from 'root/src/client/logic/form/selectors/formTogglesSelector'
import fieldSectionsTogglesSelector from 'root/src/client/logic/form/selectors/fieldSectionsTogglesSelector'

import submitForm from 'root/src/client/logic/form/thunks/submitForm'
import prePopulateForm from 'root/src/client/logic/form/thunks/prePopulateForm'
import setInput from 'root/src/client/logic/form/thunks/setInput'
import accountDataSelector from 'root/src/client/logic/userData/selectors/accountDataSelector'

export default reduxConnector(
	[
		['formFieldTypes', formFieldTypes],
		['formSubmits', formSubmits],
		['postFormSubmits', postFormSubmits],
		['formTitle', formTitle],
		['subTitle', formSubTitle],
		['preSubmitText', formPreSubmitText],
		['postSubmitText', formPostSubmitText],
		['preSubmitCaption', formPreSubmitCaption],
		['postSubmitCaption', formPostSubmitCaption],
		['creatorData', creatorDataSelector],
		['accountData', accountDataSelector],
		['formType', formType],
		['links', linksSelector],
		['headerType', headerTypeSelector],
		['formSubmitError', formSubmitError],
		['visibleLoadingBlock', visibleLoadingBlockSelector],
		['cancelButton', cancelButton],
		['isAuthenticated', isAuthenticated],
		['isMobileRes', isMobileResSelector],
		['submitsFullWidth', submitsFullWidth],
		['formFullWidth', formFullWidth],
		['doubleColumn', doubleColumn],
		['formOutput', formOutputSelector],
		['formOutputData', formOutputData],
		['prePopulateFormOn', prePopulateFormOnSelector],
		['fieldSections', fieldSectionsSelector],
		['fieldSectionsHeaders', fieldSectionsHeadersSelector],
		['submitsRow', submitsRowSelector],
		['fieldTheme', fieldThemeSelector],
		['tabError', tabErrorSelector],
		['hotjarRecording', hotjarRecordingSelector],
		['hideSubmitError', hideSubmitErrorSelector],
		['previousRoute', previousRouteSelector],
		['formToggles', formTogglesSelector],
		['fieldSectionsToggles', fieldSectionsTogglesSelector],
	],
	[
		['submitForm', submitForm],
		['prePopulateForm', prePopulateForm],
		['setInput', setInput],
	],
)
